import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
import faqData from '../data/faqData.json';

const FAQs = () => {
  const [openId, setOpenId] = useState(null);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-16 px-6 bg-white text-center mx-2 md:mx-24">
      <h2 className="text-2xl md:text-3xl font-bold text-acBlack mb-4">Frequently Asked Questions</h2>
      <p className="text-md text-acGray font-light mb-8">Everything you need to know about our immigration services and process.</p>
      <div className="max-w-4xl mx-auto">
        {faqData.map((faq) => (
          <div key={faq.id} className="border-b border-gray-300 py-4">
            <button 
              className="w-full text-left flex justify-between items-center font-medium text-lg text-acBlack focus:outline-none" 
              onClick={() => toggleFAQ(faq.id)}
            >
              {faq.question}
              <ChevronDown size={20} className={`transition-transform ${openId === faq.id ? 'rotate-180' : ''}`} />
            </button>

            <motion.div
              className="overflow-hidden"
              initial={{ height: 0, opacity: 0 }}
              animate={openId === faq.id ? { height: 'auto', opacity: 1 } : { height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
              <div className="text-acGray mt-2 text-sm text-left">
                {faq.answer.map((paragraph, index) => (
                  <p key={index} className="mb-2">{paragraph}</p>
                ))}
              </div>
            </motion.div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQs;
